import moment from "moment";
import { scopeType } from "../models/scopes.model";

export const dateNavigator = (
	startDate: Date,
	endDate: Date,
	scope: scopeType,
	operator: "add" | "subtract",
	current = false,
) => {
	let newStartDate: Date;
	let newEndDate: Date = endDate;

	if (current) {
		newEndDate = new Date();
		if (scope === "custom") {
			// If scope is custom, keep the same startDate
			newStartDate = startDate;
		} else {
			const [quantity, duration] = scope.split(" ");
			newStartDate = moment(newEndDate)
				.subtract(
					quantity,
					duration[0] as moment.unitOfTime.DurationConstructor,
				)
				.toDate();
		}
	} else {
		if (scope === "custom") {
			const durationInMs = moment(endDate).diff(moment(startDate));
			newStartDate = moment(startDate)[operator](durationInMs).toDate();
		} else {
			const [quantity, duration] = scope.split(" ");
			newStartDate = moment(startDate)
				[operator](
					quantity,
					duration[0] as moment.unitOfTime.DurationConstructor,
				)
				.toDate();
			newEndDate = moment(endDate)
				[operator](
					quantity,
					duration[0] as moment.unitOfTime.DurationConstructor,
				)
				.toDate();
		}
	}

	return { newStartDate, newEndDate };
};
